export enum AXNUIThemingTabTypes {
    LAYOUT = "axnui-theming-layout",
    HEADER = "axnui-theming-header",
    FOOTER = "axnui-theming-footer",
    ACTION_BUTTON = "axnui-theming-action-button",
    FORM_PANEL = "axnui-theming-form-panel",
    PRE_FORM_CONTENT_SLOT = "axnui-theming-pre-form-content-slot",
    FORM_CONTENT = "axnui-theming-form-content",
    POST_FORM_CONTENT_SLOT = "axnui-theming-post-form-content-slot",
    POST_SUBMIT_CONTENT_SLOT = "axnui-theming-post-submit-content-slot",
    SUCCESS_PAGE = "axnui-theming-success-page",
    POLICY_RETRY_MESSAGE = "axnui-theming-policy-retry-message",
    ERROR_PAGE = "axnui-theming-error-page",
    CUSTOM_CSS = "axnui-theming-custom-css",
    MESSAGING = "axnui-theming-messaging",
    LANDING_PAGE = "axnui-theming-landing-page",
    ASYNC_WAITING_PAGE = "axnui-theming-async-waiting-page",
    MOBILE_COMPLETE_PAGE = "axnui-theming-mobile-complete-page",
    KBA_FORM = "axnui-theming-kba-form"
}